export type FeedbackTone = 'success' | 'error' | 'info'

export interface FeedbackNotice {
  id: number
  tone: FeedbackTone
  message: string
}

type FeedbackListener = (notice: FeedbackNotice) => void

const listeners = new Set<FeedbackListener>()
let nextId = 0

export function subscribeFeedback(listener: FeedbackListener) {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

export function showFeedback(message: string, tone: FeedbackTone = 'error') {
  const notice = { id: ++nextId, tone, message }
  listeners.forEach(listener => listener(notice))
}
